// extracted by mini-css-extract-plugin
export default {"footer":"GlobalFooter_footer__TPcJK","copyright":"GlobalFooter_copyright__NEKyo"};